import React from 'react';
import { Outlet } from 'react-router-dom';
import MainLayout from '../components/MainLayout';

export default function PublicRoute({ displayNavbar = true, displayHeader = true }: any) {
  return <MainLayout displayNavbar={displayNavbar} displayHeader={displayHeader}><Outlet /></MainLayout>;
}
